import { createOceanyAuth } from "@vida/oceany-auth";
import {
  getClientId,
  getCognitoDomain,
  getLoginUrl,
  getPostLogoutRedirect,
  getRedirectUri,
  getSessionBrokerUrl,
} from "./config";

export type { TokenBundle } from "@vida/oceany-auth";

const auth = createOceanyAuth({
  storageKeyPrefix: "vida_surf",
  getClientId,
  getCognitoDomain,
  getRedirectUri,
  getPostLogoutRedirect,
  getSessionBrokerUrl,
  getLoginUrl,
  returnPathPersist: true,
  loginAlertMessage:
    "Config OAuth mancante. Esegui: bash cloud/scripts/surf-web-sync-env.sh e riavvia npm run surf:dev",
});

export const SK_RETURN_PATH = auth.SK_RETURN_PATH;
export const {
  loadTokens,
  saveTokens,
  clearTokens,
  setRememberMe,
  getRememberMe,
  saveReturnPath,
  peekReturnPath,
  consumeReturnPath,
  captureReturnPathFromSearch,
  loginPathWithReturn,
  clearOAuthSession,
  performLogout,
  startLogin,
  handleOAuthCallback,
  restoreSessionOnStartup,
  refreshIfNeeded,
  getIdToken,
  logoutUrl,
  decodeJwtPayload,
  currentUserSub,
  currentUserEmail,
  currentUserDisplayName,
  redirectToLogin,
} = auth;
